import 'react';
import { themed } from '@indeed/ifl-css';
import { MoreHorizontal } from '@indeed/ifl-icons';
import { jsx } from '@emotion/react';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ThemedDiv = /*#__PURE__*/themed("li", process.env.NODE_ENV === "production" ? {
  target: "e134jeov0"
} : {
  target: "e134jeov0",
  label: "ThemedDiv"
})(process.env.NODE_ENV === "production" ? {
  name: "waj7b",
  styles: "align-items:center;color:foreground.strong;opacity:0.4;display:flex;block-size:2.25rem;justify-content:center;inline-size:2.25rem"
} : {
  name: "waj7b",
  styles: "align-items:center;color:foreground.strong;opacity:0.4;display:flex;block-size:2.25rem;justify-content:center;inline-size:2.25rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBhZ2luYXRpb25FbGxpcHNpcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSWtCIiwiZmlsZSI6IlBhZ2luYXRpb25FbGxpcHNpcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgUmVhY3RFbGVtZW50IH0gZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgeyB0aGVtZWQgfSBmcm9tIFwiQGluZGVlZC9pZmwtY3NzXCI7XG5pbXBvcnQgeyBNb3JlSG9yaXpvbnRhbCB9IGZyb20gXCJAaW5kZWVkL2lmbC1pY29uc1wiO1xuXG5jb25zdCBUaGVtZWREaXYgPSB0aGVtZWQoXCJsaVwiKSh7XG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGNvbG9yOiBcImZvcmVncm91bmQuc3Ryb25nXCIsXG4gIG9wYWNpdHk6IDAuNCxcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGJsb2NrU2l6ZTogXCIyLjI1cmVtXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICBpbmxpbmVTaXplOiBcIjIuMjVyZW1cIlxufSk7XG5cbmV4cG9ydCBjb25zdCBQYWdpbmF0aW9uRWxsaXBzaXMgPSAoKTogUmVhY3RFbGVtZW50ID0+IChcbiAgPFRoZW1lZERpdj5cbiAgICA8TW9yZUhvcml6b250YWwgYXJpYS1oaWRkZW4gLz5cbiAgPC9UaGVtZWREaXY+XG4pO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const PaginationEllipsis = () => jsx(ThemedDiv, null, jsx(MoreHorizontal, {
  "aria-hidden": true
}));

export { PaginationEllipsis };
